import React, { useState, useRef, useEffect } from "react";
import api from "@/lib/api";
import { PageTitle } from "@/components/DashUI";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Bot, Send, User } from "lucide-react";

export default function AIAssistant() {
  const [sessionId] = useState(() => `sess-${Date.now()}`);
  const [messages, setMessages] = useState([
    { role: "assistant", text: "Hello — I'm the Care Placement Pro AI Assistant. I can help with outreach, scripts, follow-ups, summaries, and next actions. I won't give medical, legal, or financial advice or promise earnings. How can I help today?" },
  ]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const endRef = useRef(null);
  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth" }); }, [messages]);

  const send = async (e) => {
    e.preventDefault();
    if (!input.trim()) return;
    const msg = input; setInput("");
    setMessages((m) => [...m, { role: "user", text: msg }]);
    setLoading(true);
    try {
      const { data } = await api.post("/agent/ai/chat", { session_id: sessionId, message: msg });
      setMessages((m) => [...m, { role: "assistant", text: data.output }]);
    } catch {
      setMessages((m) => [...m, { role: "assistant", text: "The AI engine is temporarily unavailable. Please try again shortly." }]);
    } finally { setLoading(false); }
  };

  return (
    <div>
      <PageTitle title="AI Assistant" subtitle="Your business-development co-pilot" />
      <Card className="flex h-[calc(100vh-14rem)] flex-col">
        <div className="flex-1 space-y-4 overflow-y-auto p-6" data-testid="ai-messages">
          {messages.map((m, i) => (
            <div key={i} className={`flex gap-3 ${m.role === "user" ? "flex-row-reverse" : ""}`}>
              <div className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full ${m.role === "user" ? "bg-navy" : "bg-clinical"}`}>
                {m.role === "user" ? <User className="h-4 w-4 text-white" /> : <Bot className="h-4 w-4 text-white" />}
              </div>
              <div className={`max-w-[80%] whitespace-pre-wrap rounded-2xl px-4 py-2.5 text-sm ${
                m.role === "user" ? "bg-navy text-white" : "bg-slate-100 text-slate-700"}`}>{m.text}</div>
            </div>
          ))}
          {loading && <div className="flex gap-3"><div className="flex h-8 w-8 items-center justify-center rounded-full bg-clinical"><Bot className="h-4 w-4 text-white" /></div><div className="rounded-2xl bg-slate-100 px-4 py-2.5 text-sm text-slate-400">Thinking…</div></div>}
          <div ref={endRef} />
        </div>
        <form onSubmit={send} className="flex gap-2 border-t border-slate-200 p-4">
          <Input data-testid="ai-input" value={input} onChange={(e) => setInput(e.target.value)} placeholder="Ask for outreach help, a script, a summary…" />
          <Button type="submit" data-testid="ai-send-btn" disabled={loading} className="bg-clinical hover:bg-clinical/90"><Send className="h-4 w-4" /></Button>
        </form>
      </Card>
    </div>
  );
}
